function isNumber(value: string | number): boolean {
  if (
    typeof value === 'number' ||
    (typeof value === 'string' && value.trim() !== '')
  ) {
    const parsedValue = parseFloat(value.toString())

    return !isNaN(parsedValue)
  }

  return false
}

export const currencyFormatter = (value: string | number): string => {
  // TODO: FIX VALIDATE
  // const parsedValue = String(value).replace(',', '.')

  // if (!isNumber(parsedValue)) {
  //   return '0'
  // }

  if (value === undefined || value === null) {
    return '0'
  }

  return Number(value)?.toLocaleString('pt', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
